import { create } from 'zustand';

type GlobalContextStore = {
  isSidebarOpen: boolean;
  setIsSidebarOpen: (st: boolean) => void;
};

export const useGlobalContextStore = create<GlobalContextStore>()((set) => ({
  isSidebarOpen: true,
  setIsSidebarOpen: (isSidebarOpen) => set({ isSidebarOpen }),
}));
